// function to get the domain of the current shop
function getShopDomain() {
    let shopDomain = document.domain;
    return shopDomain;
  }
 document.addEventListener('DOMContentLoaded', function(){
   if (!customElements.get('localization-form')) {
  // custom element for the localization form
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
  
      // initialize the elements for the form
      this.elements = {
        input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
  
      // add event listeners for opening and closing the selector
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      // add event listeners for selecting a country
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  
    // function to hide the country selector panel
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  
    // function to handle keyup events on the form container
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    // function to handle clicking on a country
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      const returnToInput = form.querySelector("input[name='return_to']");
      let countryCode = event.currentTarget.dataset.value;
      let urlCountryRedirect = '';
      if (returnToInput.value.includes('?')) {
        urlCountryRedirect = '&mdApp_countryCodeDomain=' + countryCode;
      } else {
        urlCountryRedirect = '?mdApp_countryCodeDomain=' + countryCode;
      }
      returnToInput.value = returnToInput.value + urlCountryRedirect;
      document.cookie = `mdApp_countryCodeDomain=${countryCode}; domain=${getShopDomain()}; path=/; max-age=${60 * 60 * 24 * 60};`;
      this.elements.input.value = countryCode;
      if (form) form.submit();
    }
  
    // function to open the country selector panel
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      const allMegaMenus = document.querySelectorAll('.alt-mega');
      let helpModal = document.querySelector('.help-modal');
      
      helpModal.style.display = 'none'
      allMegaMenus.forEach(menu => {
        menu.style.opacity = '0';
        menu.style.pointerEvents = 'none';
        menu.parentElement.querySelector('.mega-menu-trigger').classList.remove('active')
      })
    }
  
    // function to close the country selector panel
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  
  // define the custom element
  customElements.define('localization-form', LocalizationForm);
   }
});
